import { Button, Icon } from '@/shared/ui';

interface EntityEditLinkProps {
  /** Zobrazený text entity (např. název seriálu nebo „kód · název" produktu). */
  children: React.ReactNode;
  /** Otevře detail entity (editační agendu). */
  onEdit: () => void;
  /** Tooltip / aria-label editačního tlačítka. */
  editLabel: string;
}

/**
 * Text entity následovaný malým editačním tlačítkem (ikona tužky) — otevře detail entity. Sdílený primitiv
 * pro odkazy na související entity (produkt, seriál) v hlavičkách a formulářích planneru. Používá standardní
 * ghost icon tlačítko s ikonou `edit` (stejné jako jinde v aplikaci), ne textový odkaz.
 */
export function EntityEditLink({ children, onEdit, editLabel }: EntityEditLinkProps) {
  return (
    <span className="gap-phx-1 inline-flex items-center">
      {children}
      <Button size="icon-sm" variant="ghost" title={editLabel} onClick={onEdit}>
        <Icon name="edit" size={12} />
      </Button>
    </span>
  );
}
